var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNeutered = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M13.551 2.503 13.5 2.5h-2a.5.5 0 0 0 0 1h.793L10.81 4.984A4.48 4.48 0 0 0 8 4c-.695 0-1.353.158-1.94.439l.763.764a3.5 3.5 0 0 1 4.474 4.474l.764.764a4.5 4.5 0 0 0 .44-1.941 4.48 4.48 0 0 0-.985-2.809L13 4.208V5a.5.5 0 0 0 1 0V3l-.003-.051a.5.5 0 0 0-.446-.446M2.361 3.568a.5.5 0 0 1 .707-.707L13.64 13.434a.5.5 0 1 1-.707.707l-2.124-2.125a4.5 4.5 0 0 1-6.325-6.325zm2.836 2.836 4.9 4.9a3.5 3.5 0 0 1-4.9-4.9",
  clipRule: "evenodd"
})));
export default SvgNeutered;